module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number-people-dropdown"
  }, [(!_vm.inManualEntry) ? [_c('div', {
    staticClass: "number-people-dropdown-facade"
  }, [(_vm.options.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.numGuests) + " " + _vm._s(_vm.$tc('date_and_pax_stage.number_suffix', _vm.numGuests)))]), _vm._v(" "), _c('div', {
    staticClass: "number-people-dropdown--caret"
  })] : [_c('div', {
    staticClass: "placeholder"
  })]], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numGuests),
      expression: "numGuests"
    }],
    on: {
      "input": _vm.change,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.numGuests = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])
  }), _vm._v(" "), (_vm.allowManualEntry) ? _c('option', {
    attrs: {
      "value": "activateManualEntry"
    }
  }, [_vm._v(_vm._s(_vm.max) + "+ " + _vm._s(_vm.$tc('date_and_pax_stage.number_suffix', _vm.max)))]) : _vm._e()], 2)] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.numGuests),
      expression: "numGuests",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "pattern": "\\d*"
    },
    domProps: {
      "value": (_vm.numGuests)
    },
    on: {
      "keydown": _vm.handleManualInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numGuests = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n      " + _vm._s(_vm.$tc('date_and_pax_stage.number_suffix', _vm.numGuests)) + "\n    ")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-232c5500","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdownPaxSelector.vue
// module id = 589
// module chunks = 0